/**
* In this file use to contains the physician Module profile Edite screen UI and Logic
**/
import {Link } from 'react-router-dom';
import { useState , useEffect, useRef} from 'react';
import * as Yup from 'yup';
import { validate,findDuplicateIndices,checkScheduleOverlap } from './../../../services/ValidationService';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import ApiService from './../../../services/ApiService';
import { useNavigate } from 'react-router-dom';
import ImageCroper from './../../../shared/modals/ImageCroper'
import { goBack ,convertDateToTime,convertTimeToDate,convert_DateToTime,convertS3privateToPublic,filterGeoLocation,dataURItoBlob,getCountryCodeFromDialCode,handleBookedAppointmentCheck,flatPickerFormatDate } from './../../../services/UtilsService';
import { toast } from 'react-toastify';
import TimezoneSelect from 'react-timezone-select';
import { DatePicker } from 'rsuite';
import Autocomplete from 'react-google-autocomplete';
import constantVariables from './../../../dataset/constantVariables.json';
import moment from 'moment';
import AllAppointmentsCancelModal from '../../../shared/modals/AllAppointmentsCancelModal'
import Select from 'react-select';
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import { useTranslation } from 'react-i18next';

function EditProfile(){
	
	//Intial state declaration
	const [data,SetData]= useState({ out_of_office: ['["",""]']});
	const [error,SetError]=useState({});
	const [users,setUser]=useState({});
	const [loadedHospitalData, setLoadedHospitalData] = useState(null);
	const [isValid,SetIsValid]=useState(true);
	const [image, setImage] = useState('');
	const [tab,setTab]=useState(0);
	const [hospitalInfo,setHospitalInfo]=useState([{days:[],startTime:'',endTime:''}]);
	const [parentInfo,setParentInfo]=useState([{parent:'',hospital:''}]);
	const [errorHospital,setHospitalError]=useState({});
	const [errorParent,setParentError]=useState({});
	const navigate = useNavigate();
	const [show,SetShow]=useState(false);
	const [cropImge, setCropImage] = useState();
	const [dublicateInfo,setDublicateInfo]=useState([]);	
	const [modalVisible, setModalVisible] = useState(false);
	const [modalModule, setModalModule] = useState('');
	const [bookedAppointments, setBookedAppointments] = useState([]);
	const startflatpickrRef = useRef([]); // Create a ref for Flatpickr
	const endflatpickrRef = useRef([]); // Create a ref for Flatpickr
	const [valueToRemove, setValueToRemove] = useState(null); // State to hold the value to remove
	const [indexValue, setIndexValue] = useState(null); // State to hold the value to remove
	const { t } = useTranslation();

	useEffect(() => {
		console.log("Updated hospitalInfo: ", hospitalInfo);
	}, [hospitalInfo]); // This will run whenever hospitalInfo changes

	useEffect(() => {
		if (users?.hospital?.length === 1) {
			// Automatically set the hospital when only one hospital is available
			const selectedHospital = users?.hospital[0];
			const updatedHospitalInfo = hospitalInfo.map((item) => ({
				...item,
				hospital: selectedHospital.id, // Set the hospital ID directly
			}));
			setHospitalInfo(updatedHospitalInfo); // Update the state with the selected hospital
		}
	}, [users?.hospital]); // This effect will run when `users?.hospital` changes

	// update parent info hospital value
	useEffect(() => {
		if (users?.hospital?.length) {
		const selectedHospitalId =
			users?.hospital?.length === 1
			? users.hospital[0].id
			: hospitalInfo?.[0]?.hospital;

		console.log("selectedHospitalId",selectedHospitalId)
	
		// Update parentInfo if the hospital ID is determined
		if (selectedHospitalId) {
			const updatedParentInfo = parentInfo.map((item, idx) =>
			idx === 0 ? { ...item, hospital: selectedHospitalId } : item
			);
			setParentInfo(updatedParentInfo);
			console.log("updatedParentInfo",updatedParentInfo)
		}
		}
  }, [users.hospital, hospitalInfo]); // Dependencies to watch
  
	//callback function
	const handleClose = () => {
		SetShow(false);
		// Reset the file input value
		const fileInput = document.getElementById('file-6');
		if (fileInput) {
		  fileInput.value = ""; // Clear the file input so the same file can be selected again
		}
	  };
	const imageData= (data)=> setCropImage(data);

	//validate patterns
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	
		// New state for system timezone
		const [systemTimeZone, setSystemTimeZone] = useState('');

		// Set the system's timezone when the component mounts
		useEffect(() => {
			const systemTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
			setSystemTimeZone(systemTimeZone);
	
			setHospitalInfo((prevInfo) => prevInfo.map(item => ({
				...item,
				timeZone: item.timeZone || systemTimeZone
			})));

		}, []);

	/** 
	* To handel changeTimeZone
	* @timezone we pass the timezone value in utc format
	* @index we pass the index number
	**/
	// const changeTimeZone= async (timezone,index) =>{
	// 	const updateArr = hospitalInfo.map((item, i) => {
	// 	  if (index === i) {
	// 		return { ...item, timeZone: timezone.value };
	// 	  } else {
	// 		return item;
	// 	  }
	// 	});
	//   setHospitalInfo(updateArr);  
	//   const Errors = await validate({'hospitalInfo':updateArr}, hosFields);
	//   setHospitalError(Errors);
	// }
	const changeTimeZone= async (timezone) =>{
		const updateArr = hospitalInfo.map((item, i) => {
			return {
				...item,
				timeZone: timezone.value, // Update consultingDuration field
			};
		});
	  setHospitalInfo(updateArr);  

	  const Errors = await validate({'hospitalInfo':updateArr}, hosFields);
	  setHospitalError(Errors);
	}

	// useEffect(() => {
	// 	console.log('Updated hospitalInfo:', hospitalInfo);
	// }, [hospitalInfo]);
	
	
	/** 
	* Validation schema for physician Fields
	* @first_name pass the physician first_name in string value
	* @last_name pass the physician last_name in string value
	* @email pass the physician email in string value
	* @mobileNumber pass the physician mobileNumber in string value
	* @specialist pass the physician specialist detsil in the string value
	* @city pass the physician city in the string value
	* @state pass the physician state in the string value
	* @gender pass the physician gender in the string value
	* @zipcode pass the physician zipcode in the string value
	**/
   const phyFields = [
    { name: 'first_name', validation: Yup.string().trim().required(t('error.required')) },
    { name: 'last_name', validation: Yup.string().trim().required(t('error.required')) },
	{ 
	name: 'email', 
	validation: Yup.string()
		.email(t('error.email')) // built-in email validation
		.required(t('error.emailRequired')) 
	},
	{ name: 'mobileNumber', validation: Yup.string() },
	/* { name: 'department', validation: Yup.string().required(t('error.required')) }, */
	{ name: 'specialist', validation: Yup.string().required(t('error.required')) },
	{ name: 'city', validation: Yup.string()},
	{ name: 'state', validation: Yup.string()},
	{ name: 'gender', validation: Yup.string() },
	{
	name: 'zipcode',
	validation: Yup.string()
		.nullable() // Allows the field to be nullable
		.matches(/^[a-zA-Z0-9]+$/,t('error.zipcodeAlpha')) // Allows empty or valid number format
	//   .test('len', constantVariables.error.zipcode, function (value) {
	// 	return !value || value.length >= 5; // Only check length if value is not empty
	//   })
	},
   ];
   
    /** 
	* Validation schema for hospital Fields
	* @hospital pass the hospital id
	* @days - required field and pass the days in array format
	* @startTime pass the selected startTime value
	* @endTime pass the selected endTime value
	* @timeZone pass the selected timeZone value
	**/
    const hosFields=[
     { name: 'hospitalInfo', validation: Yup.array().of(
		Yup.object({
			//   hospital: Yup.string().required(t('error.required')),
		//   consultingDuration : Yup.string().required(t('error.required')),
		  days: Yup.array()
			.of(Yup.string())
			.min(1, t('common.selectAtleastOneDay'))
			.required(t('common.selectAtleastOneDay')),
		  startTime: Yup.string().required(t('error.required')),
		  endTime: Yup.string().required(t('error.required')),
		  //timeZone: Yup.string().required(t('error.required')),
		})) },
   ];
   
    /** 
	* Validation schema for Parent Fields
	* @parent pass the Parent id
	* @hospital pass the hospital id
	**/
       const parFields=[
     { name: 'parentInfo', validation: Yup.array().of(
		Yup.object({
		  parent: Yup.string().required(t('error.required')),
		  hospital: Yup.string().notRequired(),
		})) },
   ];
   
   /** 
   * To handle input change event 
   * @e we get the event details from the Change action
   **/
   const handleChange=async(e)=>{
	   const {name,value}=e.target;
	   e.preventDefault();
	   SetData({...data,[name]:value});
	   const Errors=await validate({[name]:value},phyFields);
	   SetError({...error,[name]:Errors[name]});
   }
  
  /** 
  * To change Visting Time(startTime and endTime)
  * @time we pass the utc time value
  * @index we pass the index Number
  * @name we pass the timeZone name
  **/
  const changeVistingTime= async (time ,index , name)=>{
	setIndexValue(index);
	const physician = hospitalInfo[index].physician;
	const days = hospitalInfo[index].days;
	const startTimeValue = name === 'startTime' ? convert_DateToTime(time) : hospitalInfo[index].startTime;
    const outofoffice = [];
    const timeZoneValue = hospitalInfo[index].timeZone;
	const endTimeValue = name === 'endTime' ? convert_DateToTime(time) : hospitalInfo[index].endTime;
	const consultingDuration = parseInt(hospitalInfo[0].consultingDuration, 10); // Convert consultingDuration to an integer

	if(name==='endTime'){
		const newEndTimeValue = convert_DateToTime(time); // New end time based on the current time
		const originalEndTimeValue = hospitalInfo[index].endTime; // Existing end time
	
		// Adjust newEndTimeValue by subtracting consultingDuration minutes
		let adjustedNewEndTimeValue = moment(newEndTimeValue, 'HH:mm')
		.subtract(consultingDuration, 'minutes') // Subtract consultingDuration in minutes
		.format('HH:mm'); // Format back to HH:mm

		 // Initialize variables to store API responses
		 let newEndTimeAppointments = [];
		 let originalEndTimeAppointments = [];
	 
		 // Call the API with the new end time
		 const isBookedWithNewEndTime = await handleBookedAppointmentCheck(
			 physician,
			 days,
			 startTimeValue,
			 adjustedNewEndTimeValue,
			 [],
			 (appointments) => {
				 newEndTimeAppointments = appointments; // Capture the appointments
			 },
			 timeZoneValue,
			 'time'
		 );
		 // Call the API with the original end time
		 const isBookedWithOriginalEndTime = await handleBookedAppointmentCheck(
			 physician,
			 days,
			 startTimeValue,
			 originalEndTimeValue,
			 [],
			 (appointments) => {
				 originalEndTimeAppointments = appointments; // Capture the appointments
			 },
			 timeZoneValue,
			 'time'
		 );

		 // Compare the responses
		 if (isBookedWithNewEndTime !== isBookedWithOriginalEndTime || (newEndTimeAppointments.length !== originalEndTimeAppointments.length)) {
			// Find missing appointments by comparing the 'id' values
		   const missingAppointmentsFromNewEndTime = originalEndTimeAppointments.filter(original => 
			   !newEndTimeAppointments.some(newApp => newApp.id === original.id)
		   );
		   const missingAppointmentsFromOriginalEndTime = newEndTimeAppointments.filter(newApp => 
			   !originalEndTimeAppointments.some(original => original.id === newApp.id)
		   );
		   // Combine the missing appointments
		   const missingAppointments = [
			   ...missingAppointmentsFromNewEndTime,
			   ...missingAppointmentsFromOriginalEndTime
		   ];
		   // Set the missing appointments
		   setBookedAppointments(missingAppointments);
			// Show the modal if the booking status differs
			setModalModule('time');
			setModalVisible(true); // Show the modal
			return; // Stop further execution
		}	
	}

	let outsideTimeAppointments = [];
	const isBooked = await handleBookedAppointmentCheck(
	physician,
	days,
	startTimeValue,
	endTimeValue,
	outofoffice,
	(appointments) => {
		// Convert start and end times to Moment objects (24-hour format) for comparison
		const startMoment = moment(startTimeValue, 'HH:mm');
		const endMoment = moment(endTimeValue, 'HH:mm');
		// Filter appointments that are outside the new time range
		outsideTimeAppointments = appointments.filter((appointment) => {
		const appointmentTime = moment.utc(appointment.time); // Convert appointment time to Moment object
		const appointmentTimeFormatted = appointmentTime.format('HH:mm'); // Convert to HH:mm format for comparison
		// Convert appointmentTimeFormatted back to a moment object for comparison
		const appointmentTimeMoment = moment(appointmentTimeFormatted, 'HH:mm');
		// Compare appointment time with the new time range in HH:mm format
		return appointmentTimeMoment.isBefore(startMoment) || appointmentTimeMoment.isAfter(endMoment);
		});
		// If there are appointments outside the new time range, show the modal
		if (outsideTimeAppointments.length > 0) {
		setBookedAppointments(outsideTimeAppointments);
		setModalModule('time');
		setModalVisible(true); // Show the modal with booked appointments
		}
	},
	timeZoneValue,
	'time'
	);
	// Stop further execution if the modal logic is triggered
	if (isBooked && outsideTimeAppointments.length > 0) {
	return; // Prevent further execution if there are outside appointments
	}

	  const updateArr = hospitalInfo.map((item, i) => {
		  if (index === i) {
			return { ...item, [name]: convert_DateToTime(time) };
		  } else {
			return item;
		  }
		});

		const selectedItem = updateArr[index];
		const { startTime, endTime } = selectedItem;
		// Validation logic for startTime and endTime
		if (name === "startTime" || name === "endTime") {
			const start = moment(startTime, "HH:mm");
			const end = moment(endTime, "HH:mm");
			if (startTime && endTime) {
				if (start.isSame(end)) {
					console.error(t('error.sameTime'));
					setHospitalError((prev) => ({
						...prev,
						[`hospitalInfo[${index}].${name}`]: t('error.sameTime'),
					}));
					// Reset the specific field (e.g., startTime) if error occurs
					updateArr[index][name] = ""; // Reset the specific field (e.g., startTime or endTime)
					// Update the state with the reset data
					setHospitalInfo(updateArr); // Update hospitalInfo state with the modified schedule
					return; // Return early if there's an error
				}
				if (start.isAfter(end)) {
					setHospitalError((prev) => ({
						...prev,
						[`hospitalInfo[${index}].${name}`]: t('error.incorrectTime'),
					}));
					// Reset the specific field (e.g., startTime) if error occurs
					updateArr[index][name] = ""; // Reset the specific field (e.g., startTime or endTime)
					// Update the state with the reset data
						setHospitalInfo(updateArr); // Update hospitalInfo state with the modified schedule
					return; // Return early if there's an error
				}
			}
		}
		// Validate for overlaps after changing visiting time (exclude the current row index to avoid self-checking)
		const newSchedule = { ...selectedItem, [name]: convert_DateToTime(time) };
		if (checkScheduleOverlaps(hospitalInfo, newSchedule, index)) {
			setHospitalError((prev) => ({
				...prev,
				[`hospitalInfo[${index}].overlap`]: `${t('common.scheduleOverlap')}`,
			}));
			// Reset the specific field (e.g., startTime) if overlap occurs
			updateArr[index][name] = ""; // Reset the specific field (e.g., startTime or endTime)
			// Update the state with the reset data
				setHospitalInfo(updateArr); // Update hospitalInfo state with the modified schedule
			return; // Return early if there's an overlap and reset field
		}
		// Clear the overlap error if no conflict is found
		setHospitalError((prev) => ({
			...prev,
			[`hospitalInfo[${index}].overlap`]: "",
		}));

	  setHospitalInfo(updateArr);  
	  const Errors = await validate({'hospitalInfo':updateArr}, hosFields);
	  setHospitalError(Errors);
	 
  }
     /** 
	 * To check phone number valid or not 
	 * @value we pass the actual phone number
	 * @country we pass the countryCode
	 * @e we get the event details from the onChange action
	 * @formattedValue we pass the country formatted Value
	 **/
   const handlePhone=async (value,country,e,formattedValue)=>{
	   const {format, dialCode, } = country;
	  SetData({...data,countryCode:'+'+dialCode,mobileNumberWithCode:formattedValue,[e.target.name]:formattedValue.split("+"+dialCode+" ")[1],countryNameCode:country?.countryCode});
      const Errors = await validate({ [e.target.name]: formattedValue }, phyFields);
      SetError({...error,[e.target.name]:Errors[e.target.name]});
      if (!formattedValue || ( format?.length === formattedValue?.length && (value.startsWith(dialCode) || dialCode.startsWith(value)))) {
	       SetIsValid(true);
	  }else{
		   SetIsValid(false);
	  }
   }

   // Function to checking Time and Days overlap in hospital schedules
	const checkScheduleOverlaps = (existingSchedules, newSchedule, indexToExclude) => {
		const { days, startTime, endTime, physician } = newSchedule;

		// Convert the new schedule start and end times to moment objects
		const newStartTime = moment(startTime, "HH:mm");
		const newEndTime = moment(endTime, "HH:mm");

		// Loop through each existing schedule to check for overlaps
		return existingSchedules.some((schedule, index) => {
			// Skip the current schedule if its index matches the one we are adding/editing
			if (index === indexToExclude) return false;

			const scheduleDays = schedule.days;  // Days of the existing schedule
			const scheduleStartTime = moment(schedule.startTime, "HH:mm");  // Start time of the existing schedule
			const scheduleEndTime = moment(schedule.endTime, "HH:mm");  // End time of the existing schedule

			// Check if the physicians are the same
			//const samePhysician = schedule.physician === physician;

			// Check if there is any overlap in days
			const hasOverlapDays = days.some(day => scheduleDays.includes(day));

			// Check if the times overlap
			const timeConflict = newStartTime.isBefore(scheduleEndTime) && newEndTime.isAfter(scheduleStartTime);

			// Ensure both the days and the times must overlap for the conflict to be true
			return hasOverlapDays && timeConflict;
		});
	};
   
   /** 
   * To add hospitalInfo
   * @e we get the event details from the click action
   * @index we pass the index value of the ui
   **/
   const addHospitalInfo = (index) => async (e) => {
    e.preventDefault();
    // const currentHospital = hospitalInfo[index]?.hospital;

    const newRow = {
        // hospital: currentHospital || '',
		// consultingDuration : '',
        days: [],
        startTime: '',
        endTime: '',
        // timeZone: systemTimeZone,
        // isHospitalLocked: !!currentHospital, // Lock if pre-filled
    };

	// Validate for overlaps (exclude the current row index to avoid self-checking)
	if (checkScheduleOverlaps(hospitalInfo, newRow, index)) {
		setHospitalError(prev => ({
			...prev,
			[`hospitalInfo[${index}].overlap`]: `${t('common.scheduleOverlap')}`,
		}));
		return;
	}
	// Clear the overlap error if no conflict
	setHospitalError(prev => ({
		...prev,
		[`hospitalInfo[${index}].overlap`]: "",
	}));

    const Errors = await validate({ 'hospitalInfo': hospitalInfo }, hosFields);
    await setHospitalError(Errors);

    if (!Object.keys(Errors).length) {
        // Add only the new row
        await setHospitalInfo(state => [...state, newRow]);

        // const Errors = await validate({ 'hospitalInfo': [newRow] }, hosFields);
        // await setHospitalError(
        //     Object.keys(Errors).reduce((acc, key) => ({ 
        //         ...acc, 
        //         [key.replace(/\[0\]/g, `[${index + 1}]`)]: Errors[key] 
        //     }), {})
        // );
    }
};

  
  /** 
   * To remove hospitalInfo
   * @e we get the event details from the click action
   * @index we pass the index value of the ui
   **/
  const removeHospitalInfo=(index)=>async(e)=>{
	const physician = hospitalInfo[index].physician;
	const days = hospitalInfo[index].days; 
	const startTime = hospitalInfo[index].startTime;
	const endTime = hospitalInfo[index].endTime;
	const outofoffice = []; 
	const timeZoneValue = hospitalInfo[index].timeZone;
	// Call the function to handle API request and modal trigger
	const isBooked = await handleBookedAppointmentCheck(physician, days, startTime, endTime, outofoffice, (appointments) => {
	setBookedAppointments(appointments);
	setModalModule('schedule');
	setValueToRemove(hospitalInfo[index]);
	setModalVisible(true);  // Show the modal with booked appointments
	},
	timeZoneValue);
	// If the appointment is booked, don't continue with the rest of the logic
	if (isBooked) {
		return;
	}

	  if(hospitalInfo.length > 1){
	    var removeArr=hospitalInfo.filter((i,idx)=> idx !==index);
		// Update hospitalInfo state with adjusted isHospitalLocked property
		const updatedHospitalInfo = removeArr.map((item, idx) => ({
			...item
			// isHospitalLocked: idx !== 0 // Unlock the first row, lock others
		}));
		setHospitalInfo(updatedHospitalInfo);
		filterHospital(updatedHospitalInfo);
	  }else{
		  await filterHospital([{}]);
		 await setHospitalInfo([{days: [],startTime:'',endTime:'',hospital: hospitalInfo && hospitalInfo[0].hospital,hospital_name:hospitalInfo && hospitalInfo[0].hospital_name,consultingDuration: hospitalInfo && hospitalInfo[0].consultingDuration}]);
		 await setHospitalError(await validate({'hospitalInfo':[]}, hosFields));
	  };
  };
  
  /** 
  * To set filter hospital list for parent tab
  * @data we pass the hospitalInfo array value
  **/
  const filterHospital=(data)=>{
	  var filterHos=[...new Set(data.map(i=>i.hospital))];
	  var filter=parentInfo.map((item) => {
		  if (!filterHos.includes(item.hospital)) {
			return { ...item, hospital: '' };
		  } else {
			return item;
		  }
		});
	 setParentInfo(filter);
  };
  
  /** 
  * To change city input 
  * @e we get the event details form the change action
  **/
  const changeCity=async(e)=>{
         const { value }=e.target;
		 var obj={};
		 if(value.trim().length ===0){
			 obj={city:'',state:''};
		 }else{
		     obj={city:value};
		 }
		 SetData((data)=>({...data,...obj}));
		 const Errors = await validate({ city:value }, phyFields);
	     SetError({...error,city:Errors['city']});
  }
  
  /** 
  * To select city input 
  * @e we get the event details from the Select action
  **/
  const selectCity=async(e)=>{ 
	     var location= await filterGeoLocation(e);
		   await SetData((data)=>({...data,...location}));
  }
  
  
  /** 
  * To handle the hospitalInfo change
  * @index  we pass the index value of the UI select
  * @e we get the event details form the change action
  **/
	const changeHospitalInfo = (index) => async (e) => {
		// e.preventDefault();
		setIndexValue(index);
		const { name, value, type, checked } = e.target;
		if(checked===false){
			const physician = hospitalInfo[index].physician;
			const days = [value]; // Create an array with the value
			const startTime = hospitalInfo[index].startTime;
			const endTime = hospitalInfo[index].endTime;
			const outofoffice = []; 
			const timeZoneValue = hospitalInfo[index].timeZone;
			// Call the function to handle API request and modal trigger
			const isBooked = await handleBookedAppointmentCheck(physician, days, startTime, endTime, outofoffice, (appointments) => {
			setBookedAppointments(appointments);
			setModalModule('days');
			setModalVisible(true);  // Show the modal with booked appointments
			setValueToRemove(value); // Capture the value for later removal
			},
			timeZoneValue);
			// If the appointment is booked, don't continue with the rest of the logic
			if (isBooked) {
			return;
			}
		}	
		const updateArr = hospitalInfo.map((item, i) => {
			if (index === i ) {
				if (type === "checkbox" && name === "DaysOptions") {
				const updatedDays = checked
					? [...item.days, value] // Add the day to the array
					: item.days.filter(day => day !== value); // Remove the day from the array
					return { 
						...item, 
						days: updatedDays, 
						hospital: hospitalInfo && hospitalInfo[0].hospital || "", 
						consultingDuration: hospitalInfo && hospitalInfo[0].consultingDuration || "" 
					};
				}
				return { ...item,[name]: value }; // Handle other field changes
			} else {
				return item; // Return unchanged items
			}
		});
	
		// Check for schedule overlap after updating the schedule
		const newSchedule = updateArr[index];
		// Validate for overlaps (exclude the current row index to avoid self-checking)
		if (checkScheduleOverlaps(hospitalInfo, newSchedule, index)) {
			setHospitalError(prev => ({
				...prev,
				[`hospitalInfo[${index}].overlap`]: `${t('common.scheduleOverlap')}`,
			}));
			return;  // Return early if there's an overlap
		}
		// Clear the overlap error if there is no conflict
		setHospitalError(prev => ({
			...prev,
			[`hospitalInfo[${index}].overlap`]: "",
		}));	  	

		setHospitalInfo(updateArr);
	
		const Errors = await validate({ hospitalInfo: updateArr }, hosFields);
		// Filter out the error for 'startTime' and 'endTime' and keep only the errors for 'days'
		const filteredErrors = Object.keys(Errors).reduce((acc, key) => {
			if (key.includes('days')) { // Indclude 'days' errors
			acc[key] = Errors[key];
			}
			return acc;
		}, {});
		
		// Set the filtered errors state
		setHospitalError(filteredErrors);
  	};
  
  
     /** 
	 * To add parentInfo
	 * @index  we pass the index value of the UI select
	 * @e we get the event details form the click action
	 **/
  const addParentInfo=(index)=>async(e)=>{
	  e.preventDefault();
	  const Errors = await validate({'parentInfo':parentInfo}, parFields);
	  setParentError(Errors);
	  if(!Object.keys(Errors).length && dublicateInfo.length===0){
		await setParentInfo(state => [...state, {parent:'',hospital:''}]);
		const Errors = await validate({'parentInfo':[{parent:'',hospital:''}]},parFields);
		await setParentError(Object.keys(Errors).reduce((acc, key) => ({ ...acc, [key.replace(/\[0\]/g, `[${index + 1}]`)]: Errors[key] }), {}));
	  }
  };
  
	/** 
	 * To remove parentInfo
	 * @index  we pass the index value of the UI select
	 * @e we get the event details form the click action
	 **/
  const removeParentInfo=(index)=>async(e)=>{
	  e.preventDefault();
	  if(parentInfo.length !==1){
	    var removeArr=parentInfo.filter((i,idx)=> idx !==index);
	    setParentInfo(removeArr);
		if((await findDuplicateIndices(removeArr,'parent','hospital')).length>0){
			const duplicateIndices = await findDuplicateIndices(removeArr,'parent','hospital');
			duplicateIndices.shift();
			await setDublicateInfo(duplicateIndices);
		  }else{
			await setDublicateInfo([]);  
		  }
	  }else{
		 await setParentInfo([{parent:'',hospital:''}]);
		 await setParentError(await validate({'parentInfo':[]}, parFields));
	  };
  };
  
  /** 
  * To handle the parentInfo change
  * @index  we pass the index value of the UI select
  * @e we get the event details form the change action
  **/
  const changeParentInfo=(index)=>async (e)=>{
	  /* e.preventDefault(); */
	  const { name,value } = e.target;
	  const updateArr = parentInfo.map((item, i) => {
		  if (index === i) {
			return { ...item, [name]: value };
		  } else {
			return item;
		  }
		});
	  await setParentInfo(updateArr);  
	  const Errors = await validate({'parentInfo':updateArr}, parFields);
	  await setParentError(Errors);
	  if((await findDuplicateIndices(updateArr,'parent','hospital')).length>0){
		const duplicateIndices = await findDuplicateIndices(updateArr,'parent','hospital');
		duplicateIndices.shift();
		await setDublicateInfo(duplicateIndices);
	  }else{
		await setDublicateInfo([]);  
	  }
  };
  
  /** 
  * To handel the form tabs navigation 
  * @page we pass the page number vlues
  * @e we get the event details form the change action
  **/
  const navChange=(page)=>async(e)=>{
	  e.preventDefault();
	  let Errors;
	  data.gender=(data.gender || data.gender===0 || data.gender===1 ) ? data.gender:'';
	   data.mobileNumber=data.mobileNumber||'';
	   data.city=data.city ? data.city:'';
	   data.state=data.state ? data.state:'';
	   data.zipcode=data.zipcode ? data.zipcode:null;
	  if(page===0){
		   Errors=await validate(data,phyFields);
		   SetError(Errors);
	  }
	  if(page===1){
		  if(!Object.keys(errorHospital).length){
				Errors={};  
		  }else{
			Errors = await validate({'hospitalInfo':hospitalInfo}, hosFields);
			setHospitalError(Errors);
		  }
	  }
	   // Check for startDate and endDate validation errors
	   	const dateErrorsExist = Object.keys(error).some((key) => {
			const fieldErrors = error[key];
			return fieldErrors?.startDate || fieldErrors?.endDate;
		});

	  if(!Object.keys(Errors).length && isValid===true && !dateErrorsExist){
		await setTab(page+1)
	  }
  }

	// Change handler for modifying out_of_office dates
	const changeOutOfOfficeInfo = async(index, field, value) => {
		setIndexValue(index);
		let newOutOfOffice = []; // Initialize newOutOfOffice as an empty array
		// Extract the start and end dates from the current out_of_office value at the given index
		let currentDateRange = data.out_of_office[index];
		let dateArray = currentDateRange ? currentDateRange.replace(/[\[\]]/g, '').split(',') : [];
		// Handle the logic for modifying the startDate or endDate
		if (field === 'startDate') {
			// If startDate is being changed, update the start date and keep the existing end date
			newOutOfOffice.push(`[${flatPickerFormatDate(value)},${dateArray[1] || flatPickerFormatDate(value)}]`);
		} else if (field === 'endDate') {
			// If endDate is being changed, update the end date and keep the existing start date
			newOutOfOffice.push(`[${dateArray[0] || flatPickerFormatDate(value)},${flatPickerFormatDate(value)}]`);
		}
		const physician = data.account;
		const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
		const startTime = '00:00';
		const endTime = '00:00';
		const outofoffice = newOutOfOffice;
		data.newOutOfOffice = newOutOfOffice;
			// Call the function to handle API request and modal trigger
			const isBooked = await handleBookedAppointmentCheck(physician, days, startTime, endTime, outofoffice, (appointments) => {
			setBookedAppointments(appointments);
			setModalModule('out_of_office');
			setModalVisible(true);  // Show the modal with booked appointments
			});
			// If the appointment is booked, don't continue with the rest of the logic
			if (isBooked) {
			return;
			}

		// Create a shallow copy of the out_of_office array
		const updatedOutOfOffice = [...data.out_of_office];
		let updatedErrors = { ...error };

		if (!updatedOutOfOffice[index]) {
			updatedOutOfOffice[index] ='["", ""]';
		}
		// Ensure the entry at the given index exists
		if (updatedOutOfOffice[index]) {
		  // Check if the entry is a string, if not handle it accordingly
		  if (typeof updatedOutOfOffice[index] === 'string') {
			// Parse the string into an array [startDate, endDate]
			const dates = updatedOutOfOffice[index]
				.replace(/\[|\]/g, "") // Remove square brackets
				.split(",")
				.map((date) =>
				typeof date === "string" ? date.trim().replace(/"/g, "") : flatPickerFormatDate(date)
			);
			//.map(date => date.trim());
			
			// Update the corresponding date
			if (field === "startDate") {
			  dates[0] = flatPickerFormatDate(value); // Update the start date
			} else if (field === "endDate") {
			  dates[1] = flatPickerFormatDate(value); // Update the end date
			}
			
			// Convert the array back into a string with the desired format
			updatedOutOfOffice[index] = `[${dates[0]},${dates[1]}]`;	

			// Validate the updated row
			const [startDate, endDate] = dates;
			const rowErrors = {};

			if (!startDate || startDate === "") {
				rowErrors.startDate = `${t('common.startDateRequired')}`;
			}
	
			// // Check if endDate is empty
			// if (!endDate || endDate === "") {
			// 	rowErrors.endDate = `${t('common.endDateRequired')}`;
			// }
			if (startDate && endDate && new Date(startDate) > new Date(endDate)) {
				rowErrors.startDate = `${t('common.startBeforeEnd')}`;
				// rowErrors.endDate = "End date must be later than start date.";
			}

			// Check for overlapping ranges
			if (startDate && endDate) {
                const currentStart = new Date(startDate);
                const currentEnd = new Date(endDate);

                // Validate against all rows in updatedOutOfOffice
                for (let i = 0; i < updatedOutOfOffice.length; i++) {
                    if (i === index) continue; // Skip the current row

                    const [otherStart, otherEnd] = updatedOutOfOffice[i]
                        .replace(/\[|\]/g, "")
                        .split(",")
                        .map((date) => flatPickerFormatDate(date));

                    if (otherStart && otherEnd) {
                        const otherStartDate = new Date(otherStart);
                        const otherEndDate = new Date(otherEnd);

                        // Check for range overlap
                        if (
                            (currentStart <= otherEndDate && currentEnd >= otherStartDate) ||
                            (otherStartDate <= currentEnd && otherEndDate >= currentStart)
                        ) {
                            rowErrors.startDate = `${t('common.datesExist')}`;
                            break;
                        }
                    }
                }
			}
			updatedErrors[`row_${index}`] = rowErrors;
			SetError(updatedErrors);

		  } else if (Array.isArray(updatedOutOfOffice[index])) {
			// If it's an array, directly update the date values
			if (field === "startDate") {
			  updatedOutOfOffice[index][0] = flatPickerFormatDate(value); // Update the start date
			} else if (field === "endDate") {
			  updatedOutOfOffice[index][1] = flatPickerFormatDate(value); // Update the end date
			}
		  } else {
			console.error(`Unexpected data format at index ${index}`);
		  }
		} else {
		  console.error(`Entry at index ${index} does not exist in out_of_office`);
		}
		
		// Update the state with the new out_of_office array
		SetData({ ...data, out_of_office: updatedOutOfOffice });
	  };
	  
	// Add a new out of office date range
	const addOutOfficeInfo = async () => {
		
		// Initialize validation errors object
		let newErrors = {};
		const seenRanges = []; // Track ranges to identify duplicates

		const updatedOutOfOffice = [...data.out_of_office];
		console.log('updatedOutOfOffice',updatedOutOfOffice);
		// Validate all rows before adding a new one
		updatedOutOfOffice.forEach((entry, index) => {
			const [startDate, endDate] = entry
            .replace(/\[|\]/g, "")
            .split(",")
            .map((date) => date.trim().replace(/"/g, ""));
			const rowErrors = {};
			
			// Check if startDate is empty
			if (!startDate || startDate === "") {
				rowErrors.startDate = `${t('common.startDateRequired')}`;
			}
	
			// Check if endDate is empty
			if (!endDate || endDate === "") {
				rowErrors.endDate = `${t('common.endDateRequired')}`;
			}

			if (startDate && endDate && new Date(startDate) > new Date(endDate)) {
				rowErrors.startDate = `${t('common.startBeforeEnd')}`;
				//rowErrors.endDate = "End date must be later than start date.";
			}

			// Check for overlapping ranges
			if (startDate && endDate) {
				const currentStart = new Date(startDate);
				const currentEnd = new Date(endDate);
	
				for (let i = 0; i < seenRanges.length; i++) {
					const { start, end, rowIndex } = seenRanges[i];
	
					// Check for overlap
					if (
						(currentStart <= end && currentEnd >= start) || // Overlapping range
						(start <= currentEnd && end >= currentStart)
					) {
						rowErrors.startDate = `${t('common.datesExist')}`;
						newErrors[`row_${rowIndex}`]?.startDate &&
							delete newErrors[`row_${rowIndex}`].startDate; // Clear error on the first occurrence
						break;
					}
				}
	
				// Add the current range to the list of seen ranges
				seenRanges.push({ start: currentStart, end: currentEnd, rowIndex: index });
			}
		
			newErrors[`row_${index}`] = rowErrors;
		});
		console.log('updatedOutOfOffice',updatedOutOfOffice);
		SetError(newErrors);
		// Add a new row only if there are no errors
		if (!Object.values(newErrors).some((row) => Object.keys(row).length > 0)) {
			updatedOutOfOffice.push('["",""]');
			SetData({ ...data, out_of_office: updatedOutOfOffice });
		}
	};
  
	
	// Remove an out of office date range
	const removeOutOfficeInfo = async (index) => {
		const updatedOutOfOffice = [...data.out_of_office];
	  
		if (data.out_of_office.length > 1) {
		  // Remove the selected row
		  const filteredOutOfOffice = updatedOutOfOffice.filter((_, idx) => idx !== index);
		  SetData({ ...data, out_of_office: filteredOutOfOffice });
	  
		  // Update errors after removal
		  const updatedError = { ...error };
		  delete updatedError[`row_${index}`];
	  
		  // Shift remaining errors to align with new indices
		  const shiftedErrors = Object.entries(updatedError).reduce((acc, [key, value]) => {
			const rowIndex = parseInt(key.split("_")[1]);
			if (rowIndex > index) {
			  acc[`row_${rowIndex - 1}`] = value;
			} else {
			  acc[key] = value;
			}
			return acc;
		  }, {});
	  
		  SetError(shiftedErrors);
		} else {
		// If only one row remains, clear the out_of_office field
		// updatedOutOfOffice[0] = '["", ""]';
		updatedOutOfOffice[0] = JSON.stringify(["",""]);

		SetData({ ...data, out_of_office: updatedOutOfOffice });
	  
		// Clear all errors for the reset row
		SetError({});
		}
	};
	  
  
  /** 
  * To handel the all 3 tabs details form submit
  * @e we get the event details from the form submit action
  **/
  const handelSubmit=async (e)=>{
	  e.preventDefault();
	  var value={};
	  let hasErrors = false;
	  const finalErrors = {};
	  const seenRanges = [];
	  
	// Check if out_of_office is ["", ""]
	if (data?.out_of_office?.every(entry => entry === '["",""]')) {
		data.out_of_office = []; // Convert to empty array
	} else {
	  data.out_of_office.forEach((entry, index) => {
			let startDate = "";
			let endDate = "";
	
			// Check the type of entry and parse accordingly
			// Validate that the entry is in the expected format
			if (typeof entry === "string" && entry.startsWith("[") && entry.endsWith("]")) {
				// const dates = entry.replace(/\[|\]/g, "").split(",");

				[startDate, endDate] = entry
					.replace(/\[|\]/g, "")
					.split(",")
					.map((date) => date.trim().replace(/"/g, ""));

				// startDate = dates[0]?.trim();
				// endDate = dates[1]?.trim();
			} else {
				console.error(`Invalid format at index ${index}:`, entry);
				finalErrors[`row_${index}`] = { format: "Invalid date format. Must be [startDate,endDate]" };
				hasErrors = true;
				return; // Skip further processing for this entry
			}
		const rowErrors = {};
	
		// Check if startDate is empty
        if (!startDate || startDate === "") {
			rowErrors.startDate = `${t('common.startDateRequired')}`;
		}

		// Check if endDate is empty
		if (!endDate || endDate === "") {
			rowErrors.endDate = `${t('common.endDateRequired')}`;
		}

		if (startDate && endDate && new Date(startDate) > new Date(endDate)) {
		  rowErrors.startDate = `${t('common.startBeforeEnd')}`;
		  //rowErrors.endDate = "End date must be later than start date.";
		}
	
		// Check for overlapping ranges
		if (startDate && endDate) {
			const currentStart = new Date(startDate);
			const currentEnd = new Date(endDate);

			for (let i = 0; i < seenRanges.length; i++) {
				const { start, end, rowIndex } = seenRanges[i];

				// Check for overlap
				if (
					(currentStart <= end && currentEnd >= start) || // Overlapping range
					(start <= currentEnd && end >= currentStart)
				) {
					rowErrors.startDate = `${t('common.datesExist')}`;
					finalErrors[`row_${rowIndex}`]?.startDate &&
						delete finalErrors[`row_${rowIndex}`].startDate; // Clear error on the first occurrence
					break;
				}
			}

			// Add the current range to the list of seen ranges
			seenRanges.push({ start: currentStart, end: currentEnd, rowIndex: index });
		}
	
		if (Object.keys(rowErrors).length > 0) {
		  setTab(1); // Focus the tab with errors (optional)
		  hasErrors = true;
		  finalErrors[`row_${index}`] = rowErrors;
		}
	  });

	  if (hasErrors) {
		SetError(finalErrors);
		return;
	  }
	}
	
	  

	  const hospitalErrors = {};
	  hospitalInfo.forEach((info, index) => {
		  if (!info.days || info.days.length === 0) {
			  hospitalErrors[`hospitalInfo[${index}].days`] = t('common.selectAtleastOneDay');
		  }
		  if (!info.startTime || info.startTime.trim() === "") {
			  hospitalErrors[`hospitalInfo[${index}].startTime`] = t('error.required');
		  }
		  if (!info.endTime || info.endTime.trim() === "") {
			  hospitalErrors[`hospitalInfo[${index}].endTime`] = t('error.required');
		  }
		  if (!info.hospital || info.hospital.trim() === "") {
			  hospitalErrors[`hospitalInfo[${index}].hospital`] = t('error.required');
		  }
		  if (!info.consultingDuration || info.consultingDuration.trim() === "") {
			  hospitalErrors[`hospitalInfo[${index}].consultingDuration`] = t('error.required');
		  }
	  });

	  // If there are errors, set them in the state and stop form submission
	  if (Object.keys(hospitalErrors).length > 0) {
		  setHospitalError(hospitalErrors); // Set the errors in state
		  await setTab(1); // Focus the tab with errors (optional)
		  return;
	  } else {
		  setHospitalError({}); // Clear errors if no issues
	  }
   

	  var hospitalTab= hospitalInfo.map(({physician ,...remaining})=>Object.keys(remaining).find((key) => remaining[key] !== ''));
	  var parentTab= parentInfo.map(({physician ,...remaining})=>Object.keys(remaining).find((key) => remaining[key] !== ''));
	 data.gender=((data.gender || data.gender===0 || data.gender===1) && data.gender !=='' ) ? data.gender:'';
		data.mobileNumber=data.mobileNumber||'';
		if(!data.countryNameCode && data.mobileNumber && data.mobileNumber!==''){
			  data.countryNameCode=await getCountryCodeFromDialCode(data.countryCode+data.mobileNumber);
		  }
	  if(Object.keys(await validate(data,phyFields)).length || isValid===false){
		SetError(await validate(data,phyFields));
		await setTab(0)
		return;
	  }else{
		  data.gender=(data.gender || data.gender===0 || data.gender===1 ) && data.gender!==''  ? data.gender:null;
		  value.physicianInfo=data;
	  }
	  
	  if(!hospitalTab.includes(undefined)){
		  if(Object.keys(await validate({'hospitalInfo':hospitalInfo}, hosFields)).length){
			 setHospitalError(await validate({'hospitalInfo':hospitalInfo}, hosFields));
			await setTab(1)
			return;
		  }else{
			  //var ids = [...new Set(hospitalInfo.map(x=>x.hospital))];
	          //value.parentInfo=ids.map(i=>({physician:data.account,hospital:i}));
			  value.hospitalInfo=hospitalInfo.map(i=>({...i,physician:data.account,hospital: hospitalInfo && hospitalInfo[0].hospital,hospital_name:hospitalInfo && hospitalInfo[0].hospital_name,consultingDuration: hospitalInfo && hospitalInfo[0].consultingDuration,timeZone: hospitalInfo && hospitalInfo[0]?.timeZone ? hospitalInfo[0]?.timeZone : systemTimeZone}));
		  }
	  }else{
		  if(Object.keys(errorHospital).length){
			setHospitalError(await validate({'hospitalInfo':hospitalInfo}, hosFields));
			await setTab(1)
			return;
		  }
	  }
	  
	  if(!parentTab.includes(undefined)){
		  if(Object.keys(await validate({'parentInfo':parentInfo}, parFields)).length || dublicateInfo.length>0 ){
			setParentError(await validate({'parentInfo':parentInfo}, parFields));
			return;
		  }else{
			  //value.parentInfo=parentInfo.map(i=>({...i,physician:data.account}));
			   value.parentInfo=parentInfo.map((item)=>{
			   return {hospital:item.hospital === null ? "" : item.hospital,parent:item.parent,physician:data.account}
		      });
		  }
	  }else{
		  if(Object.keys(errorParent).length){
			setParentError(await validate({'parentInfo':parentInfo}, parFields));
			return;
		  }
	  }
	  
	  var response=await ApiService.updatePhysician(value);
	  if(response.status===200){
		  if (cropImge !== undefined) {
					const formData = new FormData();
					const fileConvertData =await dataURItoBlob(cropImge);
					formData.append('file', fileConvertData);
					await ApiService.uploadNewPhoto(data.account,formData);
				}  
		 navigate('/physician/profile');  
		toast.success(response?.data?.message);
		
	  }else{
		  toast.error(response?.data?.error[0]?.message||'Something went wrong');
	  }
		  
  }
  
  /** 
  * To handle the image change
  * @e we get the event details from the input file Select action
  **/
  const handleFile=async (e)=>{
	  e.preventDefault();
	  const file = e.target.files[0];
	  openCropModal(file);
  }
  
  /** 
  * To open the image crop modal
  * @file we pass the image details in the base 64 bit format
  **/
  const openCropModal=async(file)=>{
	  
	  if(file){
		 let ext = file.name.split('.').pop();
		 let allowedExtensions = ['jpg', 'jpeg', 'png', 'JPEG'];
		 if (!allowedExtensions.includes(ext)) {
				toast.error(t('error.fileFormat'));
				await SetShow(false);
				 return;
			}
		if (file.size > 100 * 1024 * 1024) {
			toast.error(t('header.fileSize'));
				await SetShow(false);
				 return;
		}
		 const reader = new FileReader();
		 reader.onload = () => { setImage(reader.result) };
		 reader.readAsDataURL(file);
		 await SetShow(true);
	 }else{
		 await SetShow(false);
	 }
  }
  
  /** 
  * To handle event drag
  * @e we get the event details form the drag over action
  **/
  const handleDrag=(e)=>{
	  e.preventDefault();
  }
  
  /** 
  * To handle event drop
  * @e we get the event details from the drop over action
  **/
  const handleDrop=(e)=>{
	  e.preventDefault();
	   const { files } = e.dataTransfer;
	   openCropModal(files[0]);
  }

  	//This function is used handle change for hospital and consultingDuration
	const changeHospital = () => (e) => {
		const { value,name } = e.target;
		if(name==="hospital"){
			// Find the selected hospital in the users.hospital array
			const selectedHospital = users?.hospital?.find(hospital => hospital.id === value);

			// Update the hospitalInfo state
			const updatedHospitalInfo = hospitalInfo.map((item, i) => {
				return {
					...item,
					hospital: value, // Update the hospital field
				};
			});
			setHospitalInfo(updatedHospitalInfo);

			// Update the parentInfo state
			const updatedParentInfo = parentInfo.map((item, i) => {
				return {
					...item,
					hospital: value, // Update the hospital field
				};
			});

			setParentInfo(updatedParentInfo);

			// If hospital is selected, clear the error message for that index
			if (value.trim() !== "") {
				setHospitalError((prevErrors) => {
					const updatedErrors = { ...prevErrors };
					delete updatedErrors[`hospitalInfo[0].hospital`]; // Remove the error for this specific hospital field
					return updatedErrors;
				});
			}
		} else if (name==="consultingDuration"){
			// Update consultingDuration in hospitalInfo state
			const updatedHospitalInfo = hospitalInfo.map((item, i) => {
				return {
					...item,
					consultingDuration: value, // Update consultingDuration field
				};
			});
			setHospitalInfo(updatedHospitalInfo);
			// If consultingDuration is selected, clear the error message for that index
			if (value.trim() !== "") {
				setHospitalError((prevErrors) => {
					const updatedErrors = { ...prevErrors };
					delete updatedErrors[`hospitalInfo[0].consultingDuration`]; // Remove the error for this specific consultingDuration field
					return updatedErrors;
				});
			}
		}
	};

	//trigger the state
	useEffect(() => {
	}, [hospitalInfo]);
  
  //page intital functiona and api handeling
	useEffect(()=>{
	   (async()=>{
			const id = localStorage.getItem('id');
		     var response=await ApiService.getProfile();
			 var userResponse = await ApiService.getUsersList({list:['hospital','parent','physician','physician_mapping','parent_mapping']});
			 if(response.status===200)
				// SetData(response.data.profile);

			 	var updatedProfile = { ...response.data.profile };
					if (Array.isArray(updatedProfile.out_of_office) && updatedProfile.out_of_office.length === 0) {
					updatedProfile.out_of_office = ['["",""]'];
					}
					SetData(updatedProfile);

				response.data.hospitalInfo.length > 0 ? setHospitalInfo(response.data.hospitalInfo):setHospitalInfo([{hospital:'', days: [],startTime:'',endTime:''}]);	 	
			 if(response.data.parentInfo.length){
				 var { parentInfo } = response.data;
				 var parentTab= parentInfo.map(({parent})=>(parent !== null));
				if(!parentTab.includes(false)){
			      setParentInfo(response.data.parentInfo);
				}
			 }
			 if (response.data.profile) {
				const createdBy = response.data.profile.created_by; // Get the created_by value
				localStorage.setItem("created_by", createdBy); // Store it in localStorage with the key "created_by"
			}			
			if (userResponse.status === 200) {
				const hospitals = userResponse.data.hospital; // Array of hospitals from API response
				const mappings = userResponse.data.physician_mapping; // Array of mappings from API response
				console.log("Mapping: ", mappings);
				console.log("Hospital: ",userResponse.data);

				const localCreatedBy = localStorage.getItem('created_by'); // Value from local storage
				console.log('Local Created By:', localCreatedBy);

				// Filter hospitals to include all matching `created_by` values
				const matchingHospitals = hospitals.filter(hospital => hospital.created_by === localCreatedBy);
				console.log('Matching Hospitals:', matchingHospitals);

				// Handle non-matching case: Set all hospital data in `setUser`
				const updatedUserData = { ...userResponse.data, hospital: hospitals };
				console.log('No matching hospitals found. Setting all hospital data:', updatedUserData);

				setUser(updatedUserData);
				console.log('User data successfully set with all hospital data.');

				if (matchingHospitals.length > 0) {
					// Update user data with the full matching hospitals
					const updatedUserData = { ...userResponse.data, hospital: matchingHospitals };
					console.log('Updated User Data:', updatedUserData);

					// Ensure setUser receives the correct data
					setUser(updatedUserData);
					console.log('User data successfully set with all matching hospitals.');
				} else {
					console.warn('No matching created_by values found. Checking role and mapping.');

					// Else condition: Check mappings for `created_by_role === 4` and map to hospital
					const roleBasedMappings = mappings.filter(physician_mapping =>
						physician_mapping.physician_account === id && physician_mapping.created_by_role === 4
					);

					console.log('Role Based Mappings:', roleBasedMappings);

					// Check if any role-based mapping's `mapped_id` exists in hospital data
					const validHospitals = hospitals.filter(hospital =>
						roleBasedMappings.some(physician_mapping => physician_mapping.mapped_id === hospital.id)
					);

					console.log('Valid Hospitals from Role-Based Mapping:', validHospitals);

					if (validHospitals.length > 0) {
						console.log("Valid Hospitals Chosen:");
						validHospitals.forEach(hospital => {
							console.log(`- Hospital Name: ${hospital.name}, Hospital ID: ${hospital.id}`);
						});
					
						// Remove duplicated parents from parent_mapping
						const uniqueParentMappings = userResponse.data.parent_mapping.reduce((acc, mapping) => {
							// Check if the parent_account already exists in the accumulator
							const existingMappingIndex = acc.findIndex(m => m.parent_account === mapping.parent_account);

							if (existingMappingIndex !== -1) {
								// If it exists, check if the current mapping has a mapped_id and replace the existing one if it doesn't
								if (mapping.mapped_id !== null) {
									acc[existingMappingIndex] = mapping;
								}
							} else {
								// If it doesn't exist, add the current mapping
								acc.push(mapping);
							}

							return acc;
						}, []);

						console.log("UNIQE PARENT : ",uniqueParentMappings);

						// Filter parent data based on valid hospitals and mapping conditions
						const filteredParents = userResponse.data.parent.filter(parent =>
							uniqueParentMappings.some(mapping => {
								const isRoleValid = mapping.created_by_role === 4 || mapping.created_by_role === 3;
						
								// Log each parent's evaluation process
								console.log(`Evaluating Parent: ${parent.account}`);
						
								// if (mapping.mapped_id === null) {
								// 	console.log(
								// 		`Parent Account: ${parent.account}, Mapped ID: ${mapping.mapped_id} (null, allowing without account check), ` +
								// 		`Role Valid: ${isRoleValid}`
								// 	);
								// 	return isRoleValid;
								// }
						
								const isHospitalValid = mapping.mapped_id === null || validHospitals.some(hospital => mapping.mapped_id === hospital.id);
								const isAccountMatching = mapping.parent_account === parent.account;
						
								console.log(
									`Parent Account: ${parent.account}, Mapped ID: ${mapping.mapped_id}, ` +
									`Role Valid: ${isRoleValid}, Hospital Valid: ${isHospitalValid}, Account Match: ${isAccountMatching}`
								);
						
								return isRoleValid && isHospitalValid && isAccountMatching;
							})
						);
						
						console.log("Filtered Parent Data Length:", filteredParents.length);
						filteredParents.forEach(parent => {
							console.log(`- Parent Account: ${parent.account}`);
						});
						
					
						// Update user data with the valid hospitals and filtered parents
						const updatedUserData = {
							...userResponse.data,
							hospital: validHospitals,
							parent: filteredParents,
						};
					
						console.log('Updated User Data with Role-Based Mapping and Filtered Parents:', updatedUserData);
					
						setUser(updatedUserData);
					
						if (validHospitals.length === 1) {
							console.log(`Single Hospital Loaded: ${validHospitals[0].name}, ID: ${validHospitals[0].id}`);
							setLoadedHospitalData(updatedUserData.hospital[0]); // Set the state to trigger re-render
						}
					
						console.log('User data successfully set with role-based hospitals and filtered parents.');
					} else {
						console.warn('No matching hospitals found for the role-based mapping.');
					}						
				}
			}
		 
	   })();
   },[]);
	
	return(
	<main id="main" className="main">
	{/*import ImageCroper*/}
	<ImageCroper 
		show={show} 
		handleClose={handleClose}
		image={image}
		cropImge={imageData}
	/>
	<AllAppointmentsCancelModal
    show={modalVisible}
    onHide={() => setModalVisible(false)}
    module={modalModule}
    bookedAppointments={bookedAppointments}
    onNo={() => setModalVisible(false)}
	indexValue={indexValue} // Pass the index
	hospitalInfo={hospitalInfo} // Pass hospitalInfo
	setHospitalInfo={setHospitalInfo} // Pass setHospitalInfo
	valueToRemove={valueToRemove} // Pass valueToRemove
	physicianData={data} // Pass data
	setData = {SetData} // Pass setData
  />
	{/*Page Title Section*/}
	<div className="pagetitle clearfix">
		<div className="float-start">
		  <h1>{t('profile.editProfile')}</h1>
			<nav>
				<ol className="breadcrumb">
				  <li className="breadcrumb-item"><Link to='/physician/dashboard'>{t('sidebar.home')}</Link></li>
				  <li className="breadcrumb-item"><Link to='/physician/profile'>{t('header.myProfile')}</Link></li>
				  <li className="breadcrumb-item active">{t('profile.editProfile')}</li>
				</ol>
			</nav>
		</div>
		<div className="float-end mt-2 me-1">
			<span onClick={goBack} className="backIcon"><i className="iconly-Bold-ArrowLeftSquare"></i></span>
		</div>
	</div>
	{/*End Page Title Section*/}
	
	{/*Page Content Section*/}
	<section>
	<div className="row">
	{/*ProfileImg*/}
		<div className="col-xxl-3">
			<div className="card profile-img">
				<div className="card-body">
					<div className="upload-box d-none d-lg-block">		
						<div className="box text-center" onDrop = {handleDrop} onDragOver = {handleDrag}>
							
							<input type="file" onChange={handleFile}  name="file-6" id="file-6" className="inputfile inputfile-4"  />
							<label htmlFor="file-6">
							{cropImge && (<img  className="img-fluid d-block mx-auto" src={cropImge} alt="lo" />)}
							{(!cropImge && data && data?.photo && data?.photo ==='default.png') && <img className="img-fluid d-block mx-auto" src="/assets/img/logo-img.png" alt="IMG" />}
							{(!cropImge && data && data?.photo && data?.photo !=='default.png') && <img src={convertS3privateToPublic(data?.photo)} className="img-fluid d-block mx-auto" alt="IMG" />}
								<span>{t('common.editChange')} <br /> ({t('common.dragDrop')})</span>
							</label>
						</div>
					</div>
					<div className="text-center text-tmBlue mt-4">
						<h6>{t('profile.uploadPicture')}</h6>
					</div>
				</div>
			</div>
		</div>
		{/*ProfileInfo*/}
		
		<div className="col-xxl-9">
			<div className="card form-card profile-info ">
				<div className="card-body pt-4">
					<ul className="nav nav-pills nav-fill mb-4" id="pills-tab" role="tablist">
					  <li className="nav-item" role="presentation">
						<span onClick={()=>setTab(0)} className={tab===0?"nav-link active":"nav-link"}  type="button" role="tab" >{t('profile.physicianInfo')}</span>
					  </li>
					  <li className="nav-item" role="presentation">
						<span onClick={()=>setTab(1)} className={tab===1?"nav-link active":"nav-link"}  type="button" role="tab" >{t('profile.hospitalInfo')}</span>
					  </li>
					  <li className="nav-item" role="presentation">
						<span onClick={()=>setTab(2)} className={tab===2?"nav-link active":"nav-link"}  type="button" role="tab" >{t('profile.parentInfo')}</span>
					  </li>
					</ul>
					<div className="tab-content">							
					{/*TAB-01*/}
						{tab===0 && <div>
							<form autoComplete="off">
								<div className="row">
									<div className="col-lg-4 col-md-6">
										<div className=" form-group">
											<label> {t('profile.firstName')} </label>
											<input onChange={handleChange}  value={data.first_name?data.first_name.trim():''} name="first_name" type="text" className="form-control" placeholder={t('profile.firstName')} />
											{error && error.first_name && <span className="required">{error.first_name}</span>}
										</div>
									</div>
									<div className="col-lg-4 col-md-6">
										<div className=" form-group">
											<label> {t('profile.lastName')} </label>
											<input onChange={handleChange}  value={data.last_name?data.last_name.trim():''} name="last_name" type="text" className="form-control" placeholder={t('profile.lastName')} />
											{error && error.last_name && <span className="required">{error.last_name}</span>}
										</div>
									</div>
									<div className="col-lg-4 col-md-6">
										<div className=" form-group">
											<label>{t('profile.specialty')}</label>
											<input onChange={handleChange}  value={data.specialist?data.specialist:''} name="specialist" type="text" className="form-control" placeholder={t('common.enterSpecialty')} />
											{error && error.specialist && <span className="required">{error.specialist}</span>}
										</div>
									</div>
									{/* <div className="col-lg-6 col-md-6">
										<div className=" form-group">
											<label>{constantVariables.profile.department}</label>
											<input onChange={handleChange}  value={data.department?data.department:''} name="department" type="text" className="form-control" placeholder="Enter The department"  />
											{error && error.department && <span className="required">{error.department}</span>}
										</div>
									</div> */}
									<div className="col-lg-6 col-md-6">
										<div className=" form-group">
											<label>{t('profile.phoneNumber')}</label>
											<PhoneInput
												  inputProps={{
                                                  name: 'mobileNumber',
												  style: { width: '100%'}}}
												  country={'us'}
												   value={data?.phoneNumber?data?.phoneNumber:''}
												   onChange={handlePhone}
												/>
												{error && error.mobileNumber && <span className="required">{error.mobileNumber}</span>}
												{!isValid && !error.mobileNumber && <span className="required">{t('common.validNumber')}</span>}
										</div>
									</div>
									<div className="col-lg-6 col-md-6">
										<div className=" form-group">
											<label>{t('profile.emailAddress')}</label>
											<input onChange={handleChange}  value={data.email?data.email:''} name="email" type="text" className="form-control" placeholder="youremail@mail.com" />
											{error && error.email && <span className="required">{error.email}</span>}
										</div>
									</div>
									<div className="col-lg-6 col-md-6">
										<div className=" form-group">
											<label>{t('profile.gender')}</label>
											<select name="gender" value={data.gender!==null?data.gender:''} onChange={handleChange} className="form-select">
						                      <option value='' disabled>{t('profile.selectGender')}</option>
											<option value="0">{t('profile.male')}</option>
											<option value="1" >{t('profile.female')}</option>
											</select>
											{error && error.gender && <span className="required">{error.gender}</span>}
										</div>
									</div>
									<div className="col-lg-6 col-md-6">
										<div className=" form-group">
											<label>{t('profile.addressOne')}</label>
											<input onChange={handleChange}  value={data.address_one?data.address_one:''} name="address_one" type="text" className="form-control" placeholder={t('common.addressLine1')}  />
											{error && error.address_one && <span className="required">{error.address_one}</span>}
										</div>
									</div>
									<div className="col-lg-6 col-md-6">
										<div className=" form-group">
											<label>{t('profile.addressTwo')}</label>
											<input onChange={handleChange}  value={data.address_two?data.address_two:''} name="address_two" type="text" className="form-control" placeholder={t('common.addressLine2')} />
											{error && error.address_two && <span className="required">{error.address_two}</span>}
										</div>
									</div>
									<div className="col-lg-6 col-md-6">
										<div className=" form-group">
											<label>{t('profile.city')} </label>
											<Autocomplete
											value={data?.city?data.city:''}
											className="form-control" 
											placeholder={t('common.city')}
											onChange={changeCity}
											 onPlaceSelected={selectCity}
											types={['(cities)']}		
											/>
											{error && error.city && <span className="required">{error.city}</span>}
										</div>
									</div>
									<div className="col-lg-6 col-md-6">
										<div className=" form-group">
											<label>{t('profile.state')} </label>
											<input onChange={handleChange} readOnly value={data.state?data.state:''} name="state" type="text" className="form-control" placeholder={t('common.state')} />
											{error && error.state && !data.state && <span className="required">{error.state}</span>}
										</div>
									</div>
									<div className="col-lg-6 col-md-6">
										<div className=" form-group">
											<label>{t('profile.zipCode')} </label>
											<input onChange={handleChange}  value={data.zipcode?data.zipcode.trim():''} name="zipcode" type="text" className="form-control" placeholder={t('common.zipCode')} />
											{error && error.zipcode && <span className="required">{error.zipcode}</span>}
										</div>
									</div>
								</div>
								{/*Prev-Next Button Section*/}
								<div className="row mt-3">								
									<div className="col-lg-12 text-end">
										<button type="button" onClick={navChange(0)} className="btn btn-tmBlue btnNext"><i className="ri-arrow-right-line align-middle"></i> {t('profile.next')}</button>
									</div>
								</div>
							</form>
						</div>}								
						
						{/*TAB-02*/}
						{tab===1 && <div>
							<form autoComplete="off">
								<div className="row">																						
									<div className="col-lg-12">
										<div  className="form-group row">										
											<div className="col-lg-6 col-md-6 mb-3">
												<label>{t('profile.hospitalName')} </label>
												{/* <select name="hospital" value={hospitalInfo &&hospitalInfo[0]?.hospital} className="form-select" onChange={changeHospital()} >
													<option value="" disabled>-- Select Hospital --</option>
													{users?.hospital?.map((hospital) => (
														<option key={hospital.id} value={hospital.id}>
															{hospital.name}
														</option>
													))}
												</select> */}
												<Select
													value={
														users?.hospital?.length === 1
														? {
															value: users.hospital[0].id,
															label: users.hospital[0].name,
														}
														: users?.hospital
															?.filter((hospital) => hospital.id === hospitalInfo?.[0]?.hospital)
															?.map((hospital) => ({
																value: hospital.id,
																label: hospital.name,
															}))[0] || null
													}
													options={
													users?.hospital?.map((hospital) => ({
														value: hospital.id,
														label: hospital.name,
													})) || []
													}
													onChange={(selectedOption) =>
													changeHospital()({
														target: { name: "hospital", value: selectedOption?.value },
													})
													}
													placeholder={t('common.selectHospital')}
													classNamePrefix="react-select"
													isDisabled={users?.hospital?.length === 1} // Disable the dropdown if there's only one option
												/>
												{/* {errorHospital && errorHospital?.hospital && <span className="required">{errorHospital.hospital}</span>} */}
												{errorHospital && errorHospital[`hospitalInfo[0].hospital`] && (
													<span className="required">{errorHospital[`hospitalInfo[0].hospital`]}</span>
												)}
											</div>		
											<div className="col-lg-6 col-md-4 mb-3">
												<label>{t('profile.timeZone')}  </label>
													<div >
													<TimezoneSelect
													  name="timeZone"
													  value={hospitalInfo && hospitalInfo[0]?.timeZone ? hospitalInfo[0]?.timeZone : systemTimeZone}
													  onChange={(value) => changeTimeZone(value)}
													  labelStyle="altName"
													/>
												  </div>
													{errorHospital && (errorHospital['hospitalInfo.timeZone']) && <span className="required">{(errorHospital['hospitalInfo.timeZone'])}</span>}
											</div>	
											<div className="row">
												<div className="col-xxl-12">
													<div className="secTitle">
														<h1>{t('table.appointmentSettings')}</h1>
													</div>
												</div>
											</div>
											<div className="row">
												<div className="col-lg-4 col-md-6 mb-3">
													<label>{t('table.consultingDuration')} </label>
													<select name="consultingDuration" value={hospitalInfo &&hospitalInfo[0]?.consultingDuration || ''}  className="form-select" 
													onChange={changeHospital()}
													>
														<option value='' disabled>{t('profile.selectConsultingDuration')}</option>
														<option value="10">10 {t('common.mins')}</option>
														<option value="15">15 {t('common.mins')}</option>
														<option value="20">20 {t('common.mins')}</option>
														<option value="25">25 {t('common.mins')}</option>
														<option value="30">30 {t('common.mins')}</option>
													</select>
													{/* {errorHospital && errorHospital?.consultingDuration && <span className="required">{errorHospital.consultingDuration}</span>} */}
													{errorHospital && errorHospital[`hospitalInfo[0].consultingDuration`] &&  (
														<span className="required">{errorHospital[`hospitalInfo[0].consultingDuration`]}</span>
													)}
												</div>
											</div>
											{ hospitalInfo && hospitalInfo.map((item,i)=>( 
											<div className="row" key={i}>
												<div className="col-lg-12">
													<div className="form-group mb-0 row">
														<div className="col-lg-7 col-md-6 mb-3">
															<label>Visiting Days  </label>
															<div className="form-group mb-0 checkRadio-bg">
																{["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"].map((day, idx) => (
																	<div key={idx} className="form-check form-check-inline">
																		<input
																			className="form-check-input days_Admin"
																			type="checkbox"
																			name="DaysOptions"
																			
																			value={day}
																			checked={(hospitalInfo)[i].days.includes(day)}
																			onChange={changeHospitalInfo(i)}
																		/>
																		<label className="form-check-label">{t(`common.${day.slice(0, 2).toLowerCase()}`)}</label>
																	</div>
																))}
															</div>
															{errorHospital && errorHospital[`hospitalInfo[${i}].days`] && (
																<span className="required">{errorHospital[`hospitalInfo[${i}].days`]}</span>
															)}
														</div>

														<div className="col-lg-5 col-md-4 mb-3">
															<label>{t('profile.visitingHours')}  </label>
															<div className="d-flex">
															<div>
																<DatePicker format="hh:mm aa" value={convertTimeToDate(item.startTime)}
																showMeridian
																onSelect={(selectedTime) => {
																	if (moment(selectedTime, "hh:mm A", true).isValid()) {
																		changeVistingTime(selectedTime, i, "startTime");
																		console.log("Time selected from dropdown:", selectedTime);
																	} else {
																		console.error("Invalid time selected:", selectedTime);
																	}
																}}	
																onKeyDown={(event) => {
																	if (event.key === "Enter") {
																		const inputValue = event.target.value.trim(); // Trim to handle stray spaces
																		if (moment(inputValue, "hh:mm A", true).isValid()) {
																			changeVistingTime(inputValue, i, "startTime");
																			console.log("Valid time entered:", inputValue);
																		} else {
																			console.error("Invalid time entered:", inputValue);
																		}
																	}
																}}
																name="startTime"
																cleanable={false}
																/>
																{errorHospital && (errorHospital['hospitalInfo['+i+'].startTime']) && <span className="required mt-1 d-block">{(errorHospital['hospitalInfo['+i+'].startTime'])}</span>}
																</div>
																<div className="my-2 mx-3"> - </div>
																<div>
																<DatePicker format="hh:mm aa" value={convertTimeToDate(item.endTime)}
																showMeridian
																onSelect={(selectedTime) => {
																	if (moment(selectedTime, "hh:mm A", true).isValid()) {
																		changeVistingTime(selectedTime, i, "endTime");
																		console.log("Time selected from dropdown:", selectedTime);
																	} else {
																		console.error("Invalid time selected:", selectedTime);
																	}
																}}	
																onKeyDown={(event) => {
																	if (event.key === "Enter") {
																		const inputValue = event.target.value.trim(); // Trim to handle stray spaces
																		if (moment(inputValue, "hh:mm A", true).isValid()) {
																			changeVistingTime(inputValue, i, "endTime");
																			console.log("Valid time entered:", inputValue);
																		} else {
																			console.error("Invalid time entered:", inputValue);
																		}
																	}
																}}
																cleanable={false}
																name="endTime"
																/>
																
																{errorHospital && (errorHospital['hospitalInfo['+i+'].endTime']) && <span className="required mt-1 d-block">{(errorHospital['hospitalInfo['+i+'].endTime'])}</span>}
																</div>
															</div>
														</div>
													</div>
												</div>						
											
											{/*  Display the overlap error */}
											{errorHospital && errorHospital[`hospitalInfo[${i}].overlap`] && (
												<span className="required">{errorHospital[`hospitalInfo[${i}].overlap`]}</span>
											)}
											<div className="col-lg-1 col-md-2  mb-3">
												<label>&nbsp; </label>
												<div className="d-flex">
												<button  onClick={removeHospitalInfo(i)} type="button" className="btn btn-outline-danger py-2"><i className="ri-close-fill"></i></button>
												{hospitalInfo.length && hospitalInfo.length-1=== i && <button onClick={addHospitalInfo(i)} type="button" className="btn btn-outline-tmBlue py-2 mx-2"><i className="ri-add-fill align-middle"></i></button>}
												</div>
											</div>
											</div>))}	
										</div>	

										<div className="row mt-4">
											<div className="col-xxl-12">
												<div className="secTitle">
													<h1>{t('profile.outOfOffice')}</h1>
												</div>
											</div>
										</div>
										<div className="row">
											{(Array.isArray(data?.out_of_office) && data?.out_of_office.length > 0 
												? data?.out_of_office 
												: [["", ""]]).map((item, index) => {

												// Initialize startDate and endDate
												let startDate = "";
												let endDate = "";

												// Check the format of the item and parse accordingly
												if (Array.isArray(item)) {
													startDate = item[0]?.trim() || "";
													endDate = item[1]?.trim() || "";
												} else if (typeof item === "string") {
													const dates = item.replace(/\[|\]/g, "").split(",");
													startDate = dates[0]?.trim() || "";
													endDate = dates[1]?.trim() || "";
												}

												// Helper to format dates for input type="date"
												const formatInputDate = (date) => {
													const d = new Date(date);
													return isNaN(d) || !date ? "" : d.toISOString().split("T")[0]; // Empty string if date is invalid or null
												};

												const formattedStartDate = formatInputDate(startDate);
												const formattedEndDate = formatInputDate(endDate);

												// Get the errors for this row
      											const rowErrors = error[`row_${index}`] || {};
												const isPlaceholder = data?.out_of_office.length === 0;	

												return (
												<div className="row mb-3" key={index}>
													{/* Start Date Field */}
													{/* <div className="col-lg-3 col-md-6">
														<label>Start Date</label>
														<input
															type="date"															
															placeholder="yyyy-mm-dd"
															min={new Date().toISOString().split("T")[0]}
															name="start_date"
															className="form-control"
															onChange={(e) =>
																changeOutOfOfficeInfo(index, "startDate", e.target.value)
															}
															value={formattedStartDate} // Bind startDate or show empty if null
														/>
														{rowErrors && rowErrors.startDate && (
															<div className="text-danger">{rowErrors.startDate}</div>
														)}
													</div> */}
													<div className="col-lg-3 col-md-6 flatpicker">
														<label>{t('modal.startDate')}</label>
														<div className="input-group">
															<Flatpickr
															value={formattedStartDate} // Bind the selected date
															onChange={(selectedDates) =>
																changeOutOfOfficeInfo(index, "startDate", selectedDates[0])
															}
															options={{
																dateFormat: "Y-m-d", // Format of the date
																minDate: "today", // Minimum date as today
															}}
															placeholder={t('profile.selectDate')} // Placeholder text
															className="form-control" // Optional: Add a CSS class
															ref={(el) => (startflatpickrRef.current[index] = el)} // Correctly set ref
															/>
															{/* Calendar Icon */}
															<span className="input-group-text input-button" title="toggle"
															onClick={() => startflatpickrRef.current[index]?.flatpickr?.open()}>
																<i className="ri-calendar-line"></i>
															</span>
														</div>
														{/* Error Message */}
														{rowErrors && rowErrors.startDate && (
															<div className="text-danger">{rowErrors.startDate}</div>
														)}
													</div>
												
													{/* End Date Field */}
													<div className="col-lg-3 col-md-6 flatpicker">
														<label>{t('modal.endDate')}</label>
														{/* <input
															type="date"															
															min={new Date().toISOString().split("T")[0]}
															name="end_date"
															className="form-control"
															onChange={(e) =>
																changeOutOfOfficeInfo(index, "endDate", e.target.value)
															}
															value={formattedEndDate} // Bind parsed endDate
														/> */}
														<div className="input-group">
															<Flatpickr
															value={formattedEndDate} // Bind the selected date
															onChange={(selectedDates) =>
																changeOutOfOfficeInfo(index, "endDate", selectedDates[0])
															}
															options={{
																dateFormat: "Y-m-d", // Format of the date
																minDate: "today", // Minimum date as today
															}}
															placeholder={t('profile.selectDate')} // Placeholder text
															className="form-control" // Optional: Add a CSS class
															ref={(el) => (endflatpickrRef.current[index] = el)} // Correctly set ref
															/>
															{/* Calendar Icon */}
															<span className="input-group-text input-button" title="toggle"
															onClick={() => endflatpickrRef.current[index]?.flatpickr?.open()}>
																<i className="ri-calendar-line"></i>
															</span>
														</div>
														{rowErrors && rowErrors.endDate && (
															<div className="text-danger">{rowErrors.endDate}</div>
														)}
													</div>
												
													{/* Buttons */}
													<div className="col-lg-6 d-flex align-items-center">
														<label>&nbsp;</label>
														<div>
															<button
																type="button"
																className="btn btn-outline-danger py-2 me-2 mt-4"
																onClick={() => removeOutOfficeInfo(index)}
															>
																<i className="ri-close-fill"></i> {t('common.remove')}
															</button>
															{(isPlaceholder || data?.out_of_office.length - 1 === index) && (
																<button
																	type="button"
																	className="btn btn-outline-tmBlue py-2 mt-4"
																	onClick={addOutOfficeInfo}
																>
																	<i className="ri-add-fill align-middle"></i> {t('common.addMore')}
																</button>
															)}
														</div>
													</div>
												</div>
												);
											})}
										</div>
									</div>	
								</div>
								
								{/*Prev-Next Button Section*/}
								<div className="row mt-3">
									<div className="col-lg-12 text-end">
										<button onClick={()=>setTab(0)} type="button" className="btn btn-secondary btnPrev me-2"><i className="ri-arrow-left-line align-middle"></i> {t('profile.prev')}</button>
										<button onClick={navChange(1)} type="button" className="btn btn-tmBlue btnNext"><i className="ri-arrow-right-line align-middle"></i> {t('profile.next')}</button>
									</div>
								</div>
							</form>
						</div>}		

						{/*TAB-03*/}
						{tab===2 && <div>
							<form autoComplete="off">
								<div className="row">					
									<div className="col-lg-12">
										{ parentInfo && parentInfo.map((item,i)=>(<div key={i} className="form-group row">										
											<div className="col-lg-5 col-md-4 mb-3">
												<label>{t('profile.parentName')} </label>
												{/* <select value={item.parent} name="parent"onChange={changeParentInfo(i)} className="form-select">
													<option value="" disabled>-- Select Parent --</option>
													{users && users.parent && users.parent.map(item=>(
													<option key={item.account} value={item.account}>{item.first_name+' '+item.last_name}</option>
													))}
												</select> */}
												<Select
													value={
													users?.parent
														?.filter((option) => option.account === item?.parent)
														?.map((option) => ({
														value: option.account,
														label: `${option.first_name} ${option.last_name}`,
														}))[0] || null
													}
													options={
													users?.parent?.map((option) => ({
														value: option.account,
														label: `${option.first_name} ${option.last_name}`,
													})) || []
													}
													onChange={(selectedOption) =>
													changeParentInfo(i)({
														target: { name: "parent", value: selectedOption?.value },
													})
													}
													placeholder={t('common.selectParent')}
													classNamePrefix="react-select"
												/>
												{errorParent && (errorParent['parentInfo['+i+'].parent']) && <span className="required">{(errorParent['parentInfo['+i+'].parent'])}</span>}
											</div>										
											<div className="col-lg-5 col-md-4 mb-3">
												<label>{t('profile.hospitalName')} </label>
												{/* <select value={item.hospital || ''} name="hospital" onChange={changeParentInfo(i)} className="form-select">
										  <option value="" disabled>-- Select Parent --</option>
											{users && users.hospital && users.hospital.map((item)=>
											((hospitalInfo.map(v=>v.hospital).includes(item.id))?
											 <option key={item.id} value={item.id}>{item.name}</option>
											:''))}
										</select> */}
										<Select
													 value={
														users?.hospital?.filter((hospital) =>
															hospitalInfo.map((v) => v.hospital).includes(hospital.id)
														).length === 1
															? {
																  value: users?.hospital?.filter((hospital) =>
																	  hospitalInfo.map((v) => v.hospital).includes(hospital.id)
																  )[0]?.id,
																  label: users?.hospital?.filter((hospital) =>
																	  hospitalInfo.map((v) => v.hospital).includes(hospital.id)
																  )[0]?.name,
															  }
															: users?.hospital
																  ?.filter((hospital) =>
																	  hospitalInfo.map((v) => v.hospital).includes(hospital.id)
																  )
																  ?.map((hospital) => ({
																	  value: hospital.id,
																	  label: hospital.name,
																  }))[0] || null
													}
													options={
													users?.hospital
														?.filter((hospital) =>
														hospitalInfo.map((v) => v.hospital).includes(hospital.id)
														)
														?.map((hospital) => ({
														value: hospital.id,
														label: hospital.name,
														})) || []
													}
													onChange={(selectedOption) =>
													changeParentInfo(i)({
														target: { name: "hospital", value: selectedOption?.value },
													})
													}
													placeholder={t('common.selectHospital')}
													classNamePrefix="react-select"
													isDisabled={
														users?.hospital?.filter((hospital) =>
															hospitalInfo.map((v) => v.hospital).includes(hospital.id)
														).length === 1
													} // Disable if only one option exists
												/>
												{errorParent && (errorParent['parentInfo['+i+'].hospital']) && <span className="required">{(errorParent['parentInfo['+i+'].hospital'])}</span>}
											</div>	
											<div className="col-lg-1 col-md-2  mb-3">
												<label>&nbsp; </label>
												<div className="d-flex">
												<button  onClick={removeParentInfo(i)} type="button" className="btn btn-outline-danger py-2"><i className="ri-close-fill"></i></button>
												{parentInfo.length && parentInfo.length-1=== i && <button onClick={addParentInfo(i)} type="button" className="btn btn-outline-tmBlue py-2 mx-2"><i className="ri-add-fill align-middle"></i></button>}</div>
											</div>
											{dublicateInfo && dublicateInfo.includes(i) && <span className="required">{t('common.alreadyExist')}</span>}
										</div> ))}
									</div>	
								</div>	
								{/*Prev-Next Button Section*/}
								<div className="row">								
									<div className="col-lg-12 text-end">
										<button onClick={()=>setTab(1)} type="button" className="btn btn-secondary btnPrev me-2"><i className="ri-arrow-left-line align-middle"></i> {t('profile.prev')}</button>
										<button type="button" onClick={handelSubmit} className="btn btn-tmBlue" ><i className="ri-check-double-fill align-middle"></i> {t('profile.submit')}</button>
									</div>
								</div>
							</form>
						</div>}
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
{/* End Page Content Section */}
	
</main>
	);
};

export default EditProfile;
